import { CheckIcon } from '@heroicons/react/24/outline'
import { NavLink } from 'react-router'
import LandingFooter from '../landing/LandingFooter'
import LandingHeader from '../landing/LandingHeader'

const features = [
  'Public, always-live shareable schedule',
  'Members sign up for and swap roles themselves',
  'Recurring meeting scheduling',
  'Digest emails for upcoming meetings',
  'Speech and role history',
  'Guest join flow',
  'Fully mobile-ready for the whole club',
]

export default function Pricing() {
  return (
    <div className="bg-gray-900">
      <LandingHeader />
      <main>
        <div className="mx-auto max-w-7xl px-6 pb-24 pt-32 sm:pt-40 lg:px-8">
          <div className="mx-auto max-w-4xl text-center">
            <h1 className="text-base font-semibold leading-7 text-indigo-400">
              Pricing
            </h1>
            <p className="mt-2 text-4xl font-bold tracking-tight text-white sm:text-5xl">
              Simple pricing for every club
            </p>
            <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-gray-300">
              Start free and put your schedule online today. Run real meetings
              before you decide whether to keep it.
            </p>
          </div>
          <div className="mx-auto mt-16 max-w-xl">
            <div className="flex flex-col rounded-3xl bg-white p-8 shadow-2xl shadow-indigo-950/40 ring-1 ring-white xl:p-10">
              <h2
                id="club-plan"
                className="text-lg font-semibold leading-8 text-gray-900">
                Club
              </h2>
              <p className="mt-4 text-sm leading-6 text-gray-600">
                Everything a club needs to put its schedule online, fill every
                role, and keep members informed.
              </p>
              <p className="mt-6 flex flex-wrap items-baseline gap-x-2">
                <span className="text-4xl font-bold tracking-tight text-gray-900">
                  $0
                </span>
                <span className="text-sm font-semibold leading-6 text-gray-600">
                  for 3 months
                </span>
              </p>
              <p className="mt-2 text-sm font-semibold leading-6 text-indigo-600">
                Then $19/month. Cancel or subscribe anytime.
              </p>
              <ul className="mb-8 mt-8 space-y-3 text-sm leading-6 text-gray-600">
                {features.map((feature) => (
                  <li key={feature} className="flex gap-x-3">
                    <CheckIcon
                      className="h-6 w-5 flex-none text-indigo-600"
                      aria-hidden="true"
                    />
                    {feature}
                  </li>
                ))}
              </ul>
              <NavLink
                to="/register-club"
                aria-describedby="club-plan"
                className="mt-auto block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500">
                Start your club free
              </NavLink>
            </div>
          </div>
          <p className="mt-10 text-center text-sm leading-6 text-gray-400">
            3 months free · No credit card required · No setup fee · Nothing to
            install
          </p>
        </div>
      </main>
      <LandingFooter />
    </div>
  )
}
